import { Box, Button, H1, Icon, Link, Logo, Text } from '@betterment/samba-react';

// https://github.com/vitejs/vite/issues/19778
import BackgroundImage from '../../images/gradient_x.png?url';
import { SupportEmail } from '../../Shared/Components/SupportEmail';
import urlBuilder from '../../Shared/url-builder';
import { navigate } from '../../utils/path-helpers';

export const ErrorPageHeader = ({ householdId }: { householdId: string }) => (
  <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
    <Box css={{ display: 'flex', alignItems: 'center' }}>
      <Logo type="b4aSignatureStacked" css={{ width: '128px' }} />
      <Box css={{ borderLeft: '1px solid #c7c7c7', width: '1px', height: '20px', mx: 'space.200' }} />
      <Text
        css={{
          justifySelf: 'center',
        }}
        variant="text50"
        color="text.weak"
      >
        Add a spouse participant
      </Text>
    </Box>
    <Box>
      <Link aria-label="Exit" href={urlBuilder.getHouseholdsPage(householdId)}>
        <Icon name="X" size="small" color="icon" mode="decorative" />
      </Link>
    </Box>
  </Box>
);
export const AddSpouseParticipantErrorPage = ({ householdId }: { householdId: string }) => {
  return (
    <Box css={{ display: 'flex', height: 'lvh' }}>
      <Box css={{ backgroundColor: 'grey', alignItems: 'center', display: 'flex', flex: '1.25' }}>
        <img src={BackgroundImage} alt="" />
      </Box>
      <Box css={{ px: 'space.800', pt: 'space.400', flex: '2' }}>
        <ErrorPageHeader householdId={householdId} />
        <H1
          css={{
            mt: 'space.800',
            maxWidth: '472px',
          }}
          variant="title400"
        >
          Please contact our support team to add a spouse to this solo 401(k) plan.
        </H1>
        <Box
          css={{
            mt: 'space.200',
            mb: 'space.600',
            maxWidth: '520px',
          }}
        >
          <Text variant="text100">
            To add a spouse to an established solo 401(k) plan at Betterment, please contact us at <SupportEmail />.
          </Text>
        </Box>
        <Button variant="solidSecondary" onClick={() => navigate(urlBuilder.getHouseholdsPage(householdId))}>
          Done
        </Button>
      </Box>
    </Box>
  );
};
